const institutesData = [
  {
    "institute": "College of Allied and Healthcare,Ahmedabad",
    "type": "Private",
    "university": "Silver oak University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 10
  },
  {
    "institute": "Bapubhai Desaibhai Patel Institute of Allied and Healthcare Sciences,Changa",
    "type": "Private",
    "university": "Charotar University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 30
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 60
  },
  {
    "institute": "Smt. LP Patel Institute of Allied Health Sciences and Technology,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 20
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 60
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Dialysis Therapy Technology ( B.DTT )",
    "seats": 30
  },
  {
    "institute": "Faculty of Allied And Healthcare Sciences,Gandhinagar",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "Bachelor of Dialysis Therapy Technology ( B.DTT )",
    "seats": 30
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Bachelor of Dialysis Therapy Technology ( B.DTT )",
    "seats": 30
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Medical & Psychiatric Social Work ( B.MPSW)",
    "seats": 60
  },
  {
    "institute": "College of Allied and Healthcare,Ahmedabad",
    "type": "Private",
    "university": "Silver oak University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 30
  },
  {
    "institute": "Bapubhai Desaibhai Patel Institute of Allied and Healthcare Sciences,Changa",
    "type": "Private",
    "university": "Charotar University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 30
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "Smt. LP Patel Institute of Allied Health Sciences and Technology,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 30
  },
  {
    "institute": "Department of Bioscience, VNSGU, Surat.",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "KBS and Nataraj Sciences College,Vapi",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 30
  },
  {
    "institute": "Naran Lala College of Professional and Applied Sciences, Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "Sumandeep College of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Sumandeep University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "B.N. Patel Institute of Allied And Healthcare Science, Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 40
  },
  {
    "institute": "Shree PM Patel college of Allied and Health care Science,Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Medical Laboratory Science ( BMLS )",
    "seats": 60
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 60
  },
  {
    "institute": "Smt. LP Patel Institute of Allied Health Sciences and Technology,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 20
  },
  {
    "institute": "Faculty of Allied And Healthcare Sciences,Gandhinagar",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 20
  },
  {
    "institute": "Bapubhai Desaibhai Patel Institute of Allied and Healthcare Sciences,Changa",
    "type": "Private",
    "university": "Charotar University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 40
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 60
  },
  {
    "institute": "College of Allied and Healthcare,Ahmedabad",
    "type": "Private",
    "university": "Silver oak University",
    "course": "Bachelor of Medical Radiology and Imaging Technology ( B.MRIT )",
    "seats": 30
  },
  {
    "institute": "P.P.Savani School of Allied Heath Sciences,Surat",
    "type": "Private",
    "university": "P.P.Savani University",
    "course": "Bachelor of Occupational Therapy",
    "seats": 30
  },
  {
    "institute": "B.N. Patel Institute of Allied And Healthcare Science, Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Optometry",
    "seats": 30
  },
  {
    "institute": "Bapubhai Desaibhai Patel Institute of Allied and Healthcare Sciences,Changa",
    "type": "Private",
    "university": "Charusat",
    "course": "Bachelor of Optometry",
    "seats": 30
  },
  {
    "institute": "Diwaliba Optometry College,Surat",
    "type": "Private",
    "university": "Uka Tarsadia University",
    "course": "Bachelor of Optometry",
    "seats": 30
  },
  {
    "institute": "Hari Jyot college of Optometry,Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Optometry",
    "seats": 40
  },
  {
    "institute": "KD Institute of Optometry,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Optometry",
    "seats": 60
  },
  {
    "institute": "Nagar School of Optometry,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Optometry",
    "seats": 40
  },
  {
    "institute": "Shree Bharatimaiya College of Optometry & Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Optometry",
    "seats": 40
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Optometry",
    "seats": 30
  },
  {
    "institute": "Hari Jyot college of Optometry,Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Optometry",
    "seats": 12
  },
  {
    "institute": "Nagar School of Optometry,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Optometry",
    "seats": 16
  },
  {
    "institute": "Shree Bharatimaiya College of Optometry & Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Optometry",
    "seats": 16
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Master of Optometry",
    "seats": 10
  },
  {
    "institute": "Ahmedabad Institute of Medical Science (AIMS),Ahmededabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Ahmedabad Physiotherapy College,Ahmedabad",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Akar College of Physiotherapy, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Akshatam Physiotherapy College, Palanpur",
    "type": "Private",
    "university": "Hemchandracharya North Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Ananya College of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Apollo Institute of Physiotherapay,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Arush Physiotherapy College, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Ashok & Rita Patel Institute of Physiotherapy",
    "type": "Private",
    "university": "Charusat",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "B.N.Patel College of Physiotherapy, Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Balaji College of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "Shri Govind Guru University, Godhra",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "C. U. Shah Physiotherapy College, Surendranagar",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Chanakya College of Physiotherapy, Kachchh",
    "type": "Private",
    "university": "Krantiguru Shyamji Krishna Verma Kachchh University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Chanchalben Mafatlal Patel (C M Patel) College of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Kadi Sarva Vishwavidyalaya",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "College of Physiotherapy, K.J.Mehta T.B.Hospital Trust,Bhavagar",
    "type": "Private",
    "university": "Maharaja Krishnakumarsinhji Bhavnagar University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "College of Physiotherapy,Sumandeep Vidhyapeeth,Vadodara",
    "type": "Private",
    "university": "Sumandeep Vidhyapeeth",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Dr. Subhash University School of Physiotherapy, Junagadh",
    "type": "Private",
    "university": "Dr. Subhash University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Faculty of Physiotherapy, Vadodara",
    "type": "Private",
    "university": "Sigma University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Ganpat University Institute of Physiotherapy ( Subhadraben Sureshchandra Institute of Physiotherapy ),Mehsana",
    "type": "Private",
    "university": "Ganpat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Gcs Medical College, Hospital & Recearch Centre,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Gokul Physiotherapy College, Siddhpur, Patan",
    "type": "Private",
    "university": "Gokul Global University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Gopalbhai Revabhai Patel College of Physiotherapy ( SKUM ),Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Government Physiotherapy College, Ahmedabad",
    "type": "Government",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Government Physiotherapy College, Dahod",
    "type": "Government",
    "university": "Shri Govind Guru University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Government Physiotherapy College, Jamnagar",
    "type": "Government",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Government Physiotherapy College, Surat",
    "type": "Government",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Government Physiotherapy College, Vadodara",
    "type": "Government",
    "university": "M. S. University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "J G College of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "K D Institute of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "K.M.Patel Institute of Physiotherapy,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Kasturba Gandhi Physiotherapy College,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Krishna School of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "K. P. Patel Global University (KPGU)",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "L J Institute of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "L J University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "M.B.Gohil Institute of Medical Science & Research Centre. ( College of Physiotherapy ),Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Mahatma Gandhi Physiotherapy College, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Marwadi Education Foundation\"S Group of Institutions Faculty of Physiotherapy, Rajkot",
    "type": "Private",
    "university": "Marwadi University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Merchant Physiotherapy College, Mehsana",
    "type": "Private",
    "university": "Hemchandracharya North Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Neotech Institute of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "Shri Govind Guru University, Godhra",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Nootan College of Physiotherapy, Visnagar, Mehsana",
    "type": "Private",
    "university": "Sankalchand Patel University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Parul Insitute of Physiotherapy & Research ,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Parul Insitute of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Pioneer Physiotherapy College, Vadodara",
    "type": "Private",
    "university": "Shri Govind Guru University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Rita A. Patel Institute of Physiotherapy,Anand",
    "type": "Private",
    "university": "Cvm University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "S.S.Agrawal Institute of Physiotherapy & Medical Care Education, Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Satish Goswami College of Physiotherapy, Ahmedabad",
    "type": "Private",
    "university": "Monark University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Savitri Patel College of Physiotherapy, Valod, Tapi",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "School of Physiotherapy,Rajkot",
    "type": "Private",
    "university": "R.K.University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Sharda College of Physiotherapy,Gandhinagar",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Aryatej Institute of Physiotherapy, Morbi",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree B.G.Patel College of Physiotherapy, Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Bharatimaiya College of Optometry & Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree D. M. Patel College of Physiotherapy, Amreli",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Ghatakaran Mahavir Physiotherapy, Godhra",
    "type": "Private",
    "university": "Shri Govind Guru University, Godhra",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree K. K. Sheth Physiotherapy College, Rajkot",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Shree M.M. Shah Physiotherapy College, Mehmdavad, Kheda",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Sahajanand Institute of Physiotherapy, Bhavnagar",
    "type": "Private",
    "university": "Maharaja Krishnakumarsinhji Bhavnagar University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Swaminarayan Physiotherapy College - Ranip, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Shree Swaminarayan Physiotherapy College, Jamnagar",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shree Swaminarayan Physiotherapy College, Kalol",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Shri Dayaman Institute of Physiotherapy,Jamnagar",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shri Odhavram Physiotherapy College, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shri Suleshwari College of Physiotherapy, Bhandu, Visnagar",
    "type": "Private",
    "university": "Hemchandracharya North Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Shrimad Rajchandra College of Physiotherapy, Surat",
    "type": "Private",
    "university": "Uka Tarsadia University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Silver Oak College of Physiotherapy, Gota, Ahmedabad",
    "type": "Private",
    "university": "Silver Oak University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Smt.S.R. Shah (Rangwala) College of Physiotherapy, Mehsana",
    "type": "Private",
    "university": "Hemchandracharya North Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "SPB Physiotherapy College, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Suresh Brahmakumar Bhatt (SBB) College of Physiotherapy, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "The Sarvajanik College of Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "VPMP College of Physiotherapy,Kadi",
    "type": "Private",
    "university": "Kadi Sarva Vishwavidyalaya",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Venus Institute of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Swarnim Startup & Innovation University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Vibrant Physiotherapy College, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Bachelor of Physiotherapy",
    "seats": 50
  },
  {
    "institute": "Vidhyadeep Institute of Physiotherapy, Surat",
    "type": "Private",
    "university": "Vidhyadeep University",
    "course": "Bachelor of Physiotherapy",
    "seats": 100
  },
  {
    "institute": "Ahmedabad Institute of Medical Science (AIMS),Ahmededabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Ahmedabad Physiotherapy College,Ahmedabad",
    "type": "Private",
    "university": "Parul University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Ananya College of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 15
  },
  {
    "institute": "Apollo Institute of Physiotherapay,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Ashok & Rita Patel Institute of Physiotherapy,Anand",
    "type": "Private",
    "university": "Charusat",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "C. U. Shah Physiotherapy College, Surendranagar",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "Chanchalben Mafatlal Patel (C M Patel) College of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Kadi Sarva Vishwavidyalaya",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "College of Physiotherapy,Sumandeep Vidhyapeeth,Vadodara",
    "type": "Private",
    "university": "Sumandeep Vidhyapeeth",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Gokul Physiotherapy College, Siddhpur, Patan",
    "type": "Private",
    "university": "Gokul Global University",
    "course": "Master of Physiotherapy",
    "seats": 15
  },
  {
    "institute": "Gopalbhai Revabhai Patel College of Physiotherapy ( Skum ),Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "Government Physiotherapy College, Ahmedabad",
    "type": "Government",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "Government Physiotherapy College, Jamnagar",
    "type": "Government",
    "university": "Saurashtra University",
    "course": "Master of Physiotherapy",
    "seats": 6
  },
  {
    "institute": "Government Physiotherapy College, Surat",
    "type": "Government",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 9
  },
  {
    "institute": "Government Physiotherapy College, Vadodara",
    "type": "Government",
    "university": "M. S. University",
    "course": "Master of Physiotherapy",
    "seats": 9
  },
  {
    "institute": "Ikdrc-Its College of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University Of Transplantation Sciences",
    "course": "Master of Physiotherapy",
    "seats": 6
  },
  {
    "institute": "J G College of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "K.M.Patel Institute of Physiotherapy,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "Krishna School of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "K. P. Patel Global University (KPGU)",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "L J Institute of Physiotherapy,Ahmedabad",
    "type": "Private",
    "university": "L J University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "Marwadi Education Foundation\"S Group of Institutions Faculty of Physiotherapy, Rajkot",
    "type": "Private",
    "university": "Marwadi University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Merchant Physiotherapy College, Mehsana",
    "type": "Private",
    "university": "Hemchandracharya North Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Nootan College of Physiotherapy, Visnagar, Mehsana",
    "type": "Private",
    "university": "Sankalchand Patel University",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "Parul Insitute of Physiotherapy,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Pioneer Physiotherapy College, Vadodara",
    "type": "Private",
    "university": "Shri Govind Guru University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "S.S.Agrawal Institute of Physiotherapy & Medical Care Education, Navsari",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 6
  },
  {
    "institute": "School of Physiotherapy,Rajkot",
    "type": "Private",
    "university": "R.K.University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Sharda College of Physiotherapy,Gandhinagar",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "Shree B.G.Patel College of Physiotherapy, Anand",
    "type": "Private",
    "university": "Sardar Patel University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Shree Bharatimaiya College of Optometry & Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Shree K. K. Sheth Physiotherapy College, Rajkot",
    "type": "Private",
    "university": "Saurashtra University",
    "course": "Master of Physiotherapy",
    "seats": 24
  },
  {
    "institute": "Shree Swaminarayan Physiotherapy College - Ranip, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Shrimad Rajchandra College of Physiotherapy, Surat",
    "type": "Private",
    "university": "Uka Tarsadia University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "Silver Oak College of Physiotherapy, Gota, Ahmedabad",
    "type": "Private",
    "university": "Silver Oak University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "SPB Physiotherapy College, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 12
  },
  {
    "institute": "Suresh Brahmakumar Bhatt (SBB) College of Physiotherapy, Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 21
  },
  {
    "institute": "The Sarvajanik College of Physiotherapy, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 15
  },
  {
    "institute": "Venus Institute of Physiotherapy, Gandhinagar",
    "type": "Private",
    "university": "Swarnim Startup & Innovation University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "Vidhyadeep Institute of Physiotherapy, Surat",
    "type": "Private",
    "university": "Vidhyadeep University",
    "course": "Master of Physiotherapy",
    "seats": 18
  },
  {
    "institute": "U.N.Mehta Institute of Cardiology & Research Centre,Ahmedabad",
    "type": "Private",
    "university": "Gujarat University",
    "course": "Master of Physiotherapy",
    "seats": 6
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor of Psychology ( B.Psy )",
    "seats": 70
  },
  {
    "institute": "College of Allied and Healthcare,Ahmedabad",
    "type": "Private",
    "university": "Silver oak University",
    "course": "Bachelor of Psychology ( B.Psy )",
    "seats": 40
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelor in Radiation Therapy Technology (BRTT)",
    "seats": 20
  },
  {
    "institute": "Smt. LP Patel Institute of Allied Health Sciences and Technology,Anand",
    "type": "Private",
    "university": "Bhaikaka University",
    "course": "Bachelor in Radiation Therapy Technology (BRTT)",
    "seats": 10
  },
  {
    "institute": "Faculty of Allied And Healthcare Sciences,Gandhinagar",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "Bachelors of Emergency Medical Technologist ( B.EMT)",
    "seats": 50
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "Bachelors of Emergency Medical Technologist ( B.EMT)",
    "seats": 60
  },
  {
    "institute": "Faculty of Allied And Healthcare Sciences,Gandhinagar",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "Bachelor in Anaesthesia and Operation Theatre Technology (BAOTT)",
    "seats": 10
  },
  {
    "institute": "Sheth P.T.Mahila College of Arts and HomeScience, Vanita Vishram, Surat",
    "type": "Private",
    "university": "Veer Narmad South Gujarat University",
    "course": "B.Nutrition and Dietetics ( B.ND)",
    "seats": 60
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "B.Nutrition and Dietetics ( B.ND)",
    "seats": 60
  },
  {
    "institute": "Faculty of Allied And Healthcare Sciences,Gandhinagar",
    "type": "Private",
    "university": "Swaminarayan University",
    "course": "B.Physician Associates ( B.PA)",
    "seats": 30
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "B.Physician Associates ( B.PA)",
    "seats": 30
  },
  {
    "institute": "P. P. Savani School of Physiotherapy, Surat",
    "type": "Private",
    "university": "P. P. Savani University",
    "course": "B.Physician Associates ( B.PA)",
    "seats": 30
  },
  {
    "institute": "Parul Institute of Allied and Healthcare Sciences,Vadodara",
    "type": "Private",
    "university": "Parul University",
    "course": "B.Respiratory Technology (B.RT)",
    "seats": 30
  }
];

export default institutesData;
